module.exports = __webpack_public_path__ + "img/Employee directory Icon - white.0e3bcc09.svg";